module.exports = __webpack_public_path__ + "static/sjopenna_2k-86b27fae72619eeb61eebd5a1bd86acf.jpg";